import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss'],
})
export class PageHeaderComponent {
    /** Ícono de Material a mostrar. */
    @Input() icon: string = 'dashboard';

    /** Título principal. */
    @Input() title: string = '';

    /** Subtítulo opcional. */
    @Input() subtitle: string = '';

    /** Parte del título que se resalta con el color principal. */
    @Input() highlight: string = '';
}
